<template>
  <div class="w-full bg-white border-round">
    <!-- <div class="p-4 bg-f9 border-round">
      <div class="flex w-full items-start bordb pb-5">
      <div class="w-9/12 flex gap-3 items-center">
          <img
            src="@/assets/images/side.png"
            class="object-cover w-24 h-24 border-round"
            alt="banh"
          />

          <div>
            <small class="fsize10 text-6b6b6b opacity-80 font-medium"
              >Brained Studio</small
            >
            <h2 class="text-dark fsize14 font-semibold">Business Cards</h2>
            <p
              class="font-semibold fsize10 text-dark font-medium flex items-center"
            >
              Design Collabrates
            </p>
          </div>
        </div>
      <div class="w-3/12 flex justify-end">
          <p class="text-primary fsize16 font-semibold mb-0">₹1,000</p>
        </div>
      </div>
      <div class="flex justify-between items-center mt-3">
        <small class="fsize12 text-6b6b6b opacity-80 font-medium"
          >Any Details you'd like to mention?</small
        >
        <img src="@/assets/images/plus.png" alt="plusicon" class="w-6" />
      </div>
    </div> -->
    <div class="mt-10">
      <p class="font-semibold third-fonts" v-if="currencySymbol !== 'S$'">
        Offers & Benefits
      </p>

      <div class="grid grid-cols-1 gap-4 mt-3 bg-f9 px-6 py-2 border-round">
        <el-collapse>
          <el-collapse-item name="1" class="bgcollsp">
            <template slot="title">
              <p class="font-semibold text-6b6b6b bg-f9 mb-0">
                Apply Coupon Code
              </p>
            </template>
            <div v-for="(i, index) in this.allCoupons" :key="index">
              <div class="p-2 bg-f9 flex justify-between items-end">
                <!-- Consistent with real life: in line with the process and logic of
              real life, and comply with languages and habits that the users are
              used to; -->
                {{ i.couponCode }}
                <span
                  variant="primary"
                  class="text-primary font-semibold sm-fsize6 underline cursor-pointer"
                  v-if="i.usage == 'Used'"
                  >Used
                </span>
                <span
                  @click="selectedCoupon(i)"
                  variant="primary"
                  class="text-primary font-semibold sm-fsize6 underline cursor-pointer"
                  v-else-if="couponSelected.couponCode != i.couponCode"
                  >Apply
                </span>
                <span
                  @click="removeCoupon(i)"
                  variant="primary"
                  class="text-primary font-semibold sm-fsize6 underline"
                  v-else-if="couponSelected.couponCode === i.couponCode"
                  >Remove
                </span>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div class="mt-8">
      <p class="font-semibold third-fonts">Bill Summary</p>

      <div class="grid grid-cols-1 gap-4 mt-3 bg-f9 py-4 px-6 border-round">
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item name="1" class="bgcollsp">
            <template slot="title">
              <p class="font-semibold text-6b6b6b bg-f9 mb-0">
                Items Total (<span>{{ selected.length }}</span
                >)
              </p>
            </template>
            <div
              v-for="addOn in selected"
              :key="addOn._id"
              class="flex justify-between items-end"
            >
              <div class="">
                <div class="flex items-center">
                  <h2 class="text-dark fsize14 font-semibold">
                    {{ addOn.name }}
                  </h2>
                  <div class="buttontooltipwhite">
                    <!-- <div>
                  <feather-icon
                    v-if="addOn.name == 'Storage'"
                    icon="InfoIcon"
                    svgClasses="w-5
                    h-5"
                    class="ml-2 text-yellow"
                  />
                </div> -->
                    <!-- <div class="buttontooltiptextwhite wid-320">
                  <div class="">
                    <div class="bg-white p-5">
                      <p class="font-semibold fsize14 text-start">
                        Amount for {{ addOn.daysRemain }} Day remain till the
                        renewal date
                      </p>
                      <div class="flex items-center gap-2 pt-4">
                        <div class="fsize14 font-semibold">
                          <div>
                            <span class="border-b"
                              >₹{{ addOn.price }} x {{ addOn.daysRemain }}</span
                            >
                          </div>
                          <div><span class="ml-8">365</span></div>
                        </div>
                        <div class="text-success font-bold fsize14">
                          = ₹{{ Math.ceil(addOn.calculatedPrice) }}
                        </div>
                      </div>
                    </div>
                    <div class="bg-e9e4e4 borderr-10 pt-4 p-5">
                      <p class="text-black font-medium fsize12">
                        {{ addOn.daysRemain }} : Remaining days till renewal
                        date
                      </p>
                      <p class="text-black font-medium fsize12">
                        {{ addOn.pricePermonth }} : Amount per month
                      </p>
                      <p class="text-black font-medium fsize12">
                        365 : Total Days in a Year
                      </p>
                    </div>
                  </div>
                </div> -->
                  </div>
                </div>
                <small
                  class="fsize12 text-6b6b6b opacity-80 font-medium"
                  v-if="currencySymbol !== 'S$'"
                  >{{ addOn.quantity }}</small
                >
              </div>
              <div class="" v-if="currencySymbol !== 'S$'">
                <p class="col-4f fsize14 opacity-80 font-semibold">
                  {{ currencySymbol }}{{ Math.ceil(addOn.calculatedPrice) }}
                </p>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div
          class="flex justify-between items-end pb-2"
          v-if="currencySymbol !== 'S$'"
        >
          <div>
            <small class="fsize12 text-6b6b6b opacity-80 font-medium"
              >Taxes & Charges</small
            >
            <h2 class="text-dark fsize14 font-semibold">
              {{ gstNumberValue }}% GST
            </h2>
          </div>
          <div class="">
            <p class="col-4f fsize14 font-semibold">
              +{{ currencySymbol }}{{ gst }}
            </p>
          </div>
        </div>
        <div
          class="flex justify-between items-end bordb pb-2"
          v-if="currencySymbol !== 'S$'"
        >
          <div>
            <small class="fsize12 text-6b6b6b opacity-80 font-medium"
              >Promo Code</small
            >
            <h2 class="text-dark fsize14 font-semibold">
              {{ this.couponSelected.couponCode }}
            </h2>
          </div>
          <div class="">
            <p class="col-4f fsize14 font-semibold">
              -{{ currencySymbol }}{{ this.discountRs }}
            </p>
          </div>
        </div>
        <div
          class="flex justify-between items-center"
          v-if="currencySymbol !== 'S$'"
        >
          <div>
            <h2 class="text-dark fsize14 font-semibold">Total Amount</h2>
          </div>
          <div class="">
            <p class="col-4f fsize14 font-semibold">
              {{ currencySymbol }}
              {{
                this.isCouponSelected
                  ? grandTotal
                  : Math.floor(this.total + this.gst)
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-between w-full mt-8 px-2 items-center">
      <div v-if="currencySymbol !== 'S$'">
        <small class="col-4f fsize14 font-semibold fsize12"
          >{{ currencySymbol
          }}{{
            this.isCouponSelected
              ? grandTotal
              : Math.floor(this.total + this.gst)
          }}</small
        >
        <h2 class="text-primary fsize16 font-semibold">Bill Summary</h2>
      </div>
      <div class="">
        <vs-button
          @click="
            () => {
              processOrder();
            }
          "
          variant="primary"
          class="rounded-full bg-primary border-0 text-white font-semibold lg:py-4 md:py-3 py-2 px-8 sm-fsize14"
        >
          {{ currencySymbol === "S$" ? "Get Quote" : " Proceed to pay" }}
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script src="https://checkout.razorpay.com/v1/checkout.js"></script>
<script>
import addOnsMaster from "@/Apicall/masters/addons.js";
import "@/assets/scss/Index.scss";
import { mapState } from "vuex";
import axios from "axios";
export default {
  props: {
    selected: {
      type: Array,
      default: [],
    },
    dataGet: { type: Boolean, default: false },
    currencySymbol: {
      type: String,
    },
    gstNumberValue: {
      type: Number,
    },
  },
  data() {
    return {
      isCouponSelected: false,
      allCoupons: "",
      couponSelected: {},
      afterDiscountAmt: 0,
      discountRs: 0,
      selectedObject: false,
      activeName: "",
    };
  },

  computed: {
    ...mapState("user", ["selectedProject"]),
    ...mapState("admin", ["login"]),
    ...mapState("studio", ["getcoupons"]),
    total() {
      return this.selected.reduce((total, item) => {
        return total + item.calculatedPrice;
      }, 0);
    },

    gst() {
      let gstVal = this.gstNumberValue / 100;
      return Math.floor(this.total * gstVal);
    },

    grandTotal() {
      this.beforePrice = Math.floor(this.total + this.gst);

      if (this.isCouponSelected) {
        new Promise(async (resolve, reject) => {
          try {
            let { data } = await this.$store.dispatch("studio/submitCoupon", {
              couponCode: this.couponSelected.couponCode,
              totalPrice: Math.floor(this.total + this.gst),
            });
            console.log(data, "total");
            if (data) {
              this.discountRs = data.discountPrice;
              this.afterDiscountAmt = data.finalPrice;
            }
            // resolve(data);
          } catch (error) {
            reject(error);
          }
        });
      }
      this.beforePrice = Math.floor(this.total + this.gst);
      return Math.floor(this.afterDiscountAmt);
      // return { beforePrice, afterDiscountAmt };
    },
  },
  methods: {
    async SGMailTriggregd() {
      let payload = {
        names: "AddOns",
        projectName: this.selectedProject.projectName,
        collectionData: this.selected.name,
      };
      let { data } = this.$store.dispatch("Extensions/mailTriggred", payload);
      if (data) {
        this.$swal({
          text: "Successfully Mail Send",
          icon: "success",

          confirmButtonColor: "#830c81",
          // cancelButtonColor: "#d33",
          confirmButtonText: "Okay",
        });
      }
    },
    filterUsedCoupon() {
      this.allCoupons = this.getcoupons;
      for (let i = 0; i < this.selectedProject.couponUsed.length; i++) {
        for (let j = 0; j < this.allCoupons.length; j++) {
          if (
            this.selectedProject.couponUsed[i]._id == this.allCoupons[j]._id
          ) {
            this.allCoupons[j].usage = "Used";
          }
        }
      }
      console.log(this.allCoupons, "all coupons");
      console.log(this.selectedProject.couponUsed, "dbcoupon");
    },
    orderConfirm() {
      this.$router.push({ name: "orderConfirm" });
    },
    async getCoupons() {
      let coupon_data = await this.$store.dispatch("studio/getCoupons", {
        isExpired: true,
      });
    },
    async selectedCoupon(value) {
      this.isCouponSelected = true;
      this.isApplied = true;
      this.discountRs = 0;
      this.afterDiscountAmt = 0;
      this.couponSelected = value;
      // let { data } = await this.$store.dispatch("studio/submitCoupon", {
      //   couponCode: this.couponSelected.couponCode,
      //   totalPrice: this.grandTotal,
      // });
      // console.log(data, "this");
      // this.discountRs = data.discountPrice;
      // this.afterDiscountAmt = data.finalPrice;
    },
    removeCoupon() {
      this.isCouponSelected = false;
      this.couponSelected = {};
      this.discountRs = 0;
      this.afterDiscountAmt = 0;
    },
    removeAll() {
      this.isCouponSelected = false;
      this.couponSelected = {};
      this.discountRs = 0;
      this.afterDiscountAmt = 0;
      this.grandTotal = 0;
      this.selected = [];
      this.selectedObject = true;
      this.$emit("selectedObject", this.selectedObject);
    },
    async processOrder() {
      console.log(this.isCouponSelected, "this.isCouponSelected");
      try {
        const { data } = await axios.post(
          "https://brained-hello-api.aiab.in/brained/payment/create_order",
          {
            amount:
              (this.isCouponSelected
                ? this.grandTotal
                : Math.floor(this.total + this.gst)) * 100,
            currency: "INR",
          }
        );

        const options = {
          key: process.env.VUE_APP_RAZORPAY_KEY,
          // amount:this.selectedPlan.
          currency: "INR",
          // descriptiopn:""
          order_id: data.id,
          prefill: {
            name: this.login.name,
            email: this.login.email,
            contact: this.login.mobile,
          },
          handler: async (response) => {
            // alert(response.razorpay_order_id);
            await this.requestAddOns();
            this.removeAll();

            if (this.couponSelected) {
              const couponpayload = {
                projectId: this.selectedProject._id,
                couponUsed: this.couponSelected,
              };
              await this.$store.dispatch("user/updateProject", couponpayload);
              await this.$store.dispatch("user/getProject", {
                projectId: this.selectedProject._id,
              });
              await this.filterUsedCoupon();
            }
          },
        };
        const rzp = await new Razorpay(options);
        rzp.open();
      } catch (error) {
        console.log(error);
      }
    },

    async requestAddOns() {
      console.log(this.selected, "addons");
      await addOnsMaster.rquestAddOns({
        projectName: this.selectedProject.projectName,
        projectId: this.selectedProject._id,
        addOns: this.selected,
        payment_status: "Paid",
        CreationType: "Admin",
      });
    },
  },
  async mounted() {
    await this.getCoupons();
    await this.filterUsedCoupon();
  },
  watch: {
    dataGet(value) {
      if (value) {
        this.selectedObject = false;
        this.$emit("selectedObject", this.selectedObject);
      }
    },

    selected(val2) {
      if (val2.length) {
        if (this.currencySymbol === "S$") {
          this.activeName = "1";
        } else {
          this.activeName = "";
        }
      }
    },
  },
};
</script>
<style>
.wid-320 {
  width: 320px !important;
}
.bg-e9e4e4 {
  background-color: #e9e4e4;
}
.borderr-10 {
  border-radius: 0 0 10px 10px;
}
</style>
